import { IsNumber, IsString, MaxLength } from 'class-validator';

export class GiftCardRefundBaseRequestDto {
  @IsNumber()
  refundReasonId: number;

  @IsString()
  @MaxLength(300)
  commentReason: string;
}
